

export const COLUMNS = [
    {
        Header: "Purpose",
        Footer: "Purpose",
        accessor: "purpose",
    },
    {
        Header: "Subject",
        Footer: "Subject",
        accessor: "subject",
    },
    {
        Header: "From Name",
        Footer: "From Name",
        accessor: "fromName",
    },
    {
        Header: "From Email",
        Footer: "From Email",
        accessor: "fromEmail",
    },
    {
        Header: "Created Date",
        Footer: "Created Date",
        accessor: "createdAt",
    },
    {
        Header: "Total Email",
        Footer: "Total Email",
        accessor: "totalEmail",
    },
    {
        Header: "Total Send",
        Footer: "Total Send",
        accessor: "totalSend",
    },
    {
        Header: "Total Pending",
        Footer: "Total Pending",
        accessor: "totalPending",
    },
    {
        Header: "Total Fail",
        Footer: "Total Fail",
        accessor: "totalFail",
    },
];
